import { useMemo } from 'react';

import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { PRODUCT_TYPE } from '../constants/reviews';
import { createParamsDfp, getReviewType } from '../helpers/reviews';
import { useAdProducts } from '../store/hooks/advertising';
import { useProductsTags, useServerFilters } from '../store/hooks/filters';

interface IDfpParams {
  type: PAGE_TYPE | PRODUCT_TYPE;
  tag: string;
}

export const useParamsDfp = ({ tag, type }: IDfpParams) => {
  const serverFilters = useServerFilters();
  const adProducts = useAdProducts();
  const productsTags = useProductsTags();

  const reviewType = getReviewType(type, productsTags);

  const tagsForThisType = serverFilters[reviewType.typeForService]?.tag;
  let productAlias = tagsForThisType?.find(({ key }) => key === tag)?.alias;

  return useMemo(() => {
    const paramsDfp = createParamsDfp({
      type: reviewType,
      productAlias,
      adProducts,
    });

    return {
      paramsDfp,
      paramsForDecoratingBanners: [
        {
          teg: adProducts?.[productAlias]?.alias,
        },
      ],
    };
  }, [reviewType, productAlias, adProducts]);
};
